import { showNotification } from '../components/Notification'; // Configuração padrão do tema para notificações

const defaultTheme = {
  className: 'light'
};
const defaultRtl = {
  direction: 'ltr'
}; // Função para obter o tema atual (pode ser expandida para usar contexto)

const getCurrentTheme = () => {
  // Por enquanto usa o tema padrão, mas pode ser expandido para usar contexto
  return defaultTheme;
}; // Função para obter configuração RTL atual


const getCurrentRtl = () => {
  // Por enquanto usa RTL padrão, mas pode ser expandido para usar contexto
  return defaultRtl;
}; // Wrapper melhorado para facilitar o uso de notificações
// Compatível com o sistema existente e com o novo hook


export const notification = {
  success: (message, title = 'Sucesso') => {
    const theme = getCurrentTheme();
    const rtl = getCurrentRtl();
    showNotification(theme, rtl, title, message, 'success');
  },
  error: (message, title = 'Erro') => {
    const theme = getCurrentTheme();
    const rtl = getCurrentRtl();
    showNotification(theme, rtl, title, message, 'danger');
  },
  warning: (message, title = 'Aviso') => {
    const theme = getCurrentTheme();
    const rtl = getCurrentRtl();
    showNotification(theme, rtl, title, message, 'warning');
  },
  info: (message, title = 'Informação') => {
    const theme = getCurrentTheme();
    const rtl = getCurrentRtl();
    showNotification(theme, rtl, title, message, 'primary');
  },
  // Método para notificações customizadas
  custom: (message, title, type = 'primary', customTheme = null, customRtl = null) => {
    const theme = customTheme || getCurrentTheme();
    const rtl = customRtl || getCurrentRtl();
    showNotification(theme, rtl, title, message, type);
  }
}; // Exporta também a função showNotification para casos especiais

export { showNotification }; // Re-exporta o hook para uso opcional

export { useNotification } from '@/hooks/useNotification';
